import * as React from 'react';

// @ts-expect-error
import capitalize from 'underscore.string/capitalize';

import type {FormField} from 'shells/chat/types';

import {StackLegacy} from '../layout/stack/stack-legacy';
import {Body} from '../typography/body';

import styles from './chat-preview.module.css';

type Props = {
    selectedFields: FormField[];
    automatedMessage: string;
    hasEnabledConversationalForms: boolean;
};

const EXPECTED_FIELD_ORDER = ['name', 'email', 'phone'];

export function FormContent(props: Props) {
    const orderedSelectedFields = EXPECTED_FIELD_ORDER.filter((field) =>
        // @ts-expect-error
        props.selectedFields.includes(field)
    );

    return (
        <>
            <StackLegacy spacing={4}>
                <StackLegacy isHorizontal={true} spacing={8}>
                    <Body size='mini' isItalic={true}>
                        Automated response
                    </Body>
                </StackLegacy>
                <div className={styles['chat-bubble--outgoing']}>{props.automatedMessage}</div>
            </StackLegacy>
            <div className='flex flex-dir-col justify-sb full-height mt-8'>
                {props.hasEnabledConversationalForms ? (
                    <div className={styles['chat-bubble--outgoing']}>
                        What’s your {props.selectedFields[0]}?
                    </div>
                ) : (
                    <div className='br-3 px-16 py-8 background-offwhite flex flex-dir-col'>
                        {orderedSelectedFields.map((field) => (
                            <div
                                key={field}
                                className='flex flex-dir-col align-start gap-4 align-self-stretch overflow-hidden'
                            >
                                <label>{capitalize(field)}</label>
                                <div className='flex align-center gap-8 background-white mb-8 pad-8 full-width'>
                                    <Body size='mini' color='light' isItalic={true}>
                                        Enter {field}
                                    </Body>
                                </div>
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </>
    );
}
